<template>
  <div>
    <StandardCard :title="value.name" subheader="INFO">
      <template v-slot>
        <div v-if="loading" class="text-center pb-4">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else>
          <CardContent v-model="data" />
          <CardContentDesc descTitle="Beskrivelse" :text="value.txt" />
        </div>
      </template>
    </StandardCard>
    <EditProfileDialog v-model="editProfile" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";
import CardContentDesc from "@/components/shared/cards/children/CardContentDesc.vue";
import EditProfileDialog from "@/components/profile/children/EditProfileDialog.vue";

export default Vue.extend({
  name: "ComplaintInfoCard",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editProfile: false,
      profileItems: [
        {
          icon: "mdi-folder-pound-outline",
          title: "Id",
          content: "22469-01",
        },
        {
          icon: "mdi-account-tie-outline",
          title: "Ansvarlig",
          content: "Lars Magne",
        },
        {
          icon: "mdi-shield-account-outline",
          title: "KA",
          content: "Cathy Johnson",
        },
        {
          icon: "mdi-badge-account-horizontal-outline",
          title: "PRL",
          content: "Lilly Elblingo",
        },
        {
          icon: "mdi-truck-check-outline",
          title: "Service",
          content: "Knut Arnoldson",
        },
        {
          icon: "mdi-autorenew",
          title: "Status",
          content: "Ubehandlet",
        },
        {
          icon: "mdi-calendar-alert",
          title: "Frist",
          content: "28.09.2020",
        },
        {
          icon: "mdi-clipboard-edit-outline",
          title: "Rapportert av",
          content: "Linda Straum",
        },
      ],
    };
  },
  computed: {
    data() {
      var profileItems = [
        {
          icon: "mdi-folder-pound-outline",
          title: "Id",
          content: this.value.lineIndexLineId,
        },
        {
          icon: "mdi-account-tie-outline",
          title: "Ansvarlig",
          content: this.value.contactPersonPersonFullName,
        },
        {
          icon: "mdi-badge-account-horizontal-outline",
          title: "PRL",
          content: this.value.regHeaderResponsibleName,
        },
        {
          icon: "mdi-truck-check-outline",
          title: "Servicekoor.",
          content: this.value.regHeaderScName,
        },
        {
          icon: "mdi-shield-account-outline",
          title: "KA",
          content: this.value.regHeaderQaName,
        },
        {
          icon: "mdi-autorenew",
          title: "Status",
          content: this.value.regStatus,
        },
        {
          icon: "mdi-calendar-alert",
          title: "Frist",
          content: this.value.timeLimit
            ? moment(this.value.timeLimit).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-clipboard-edit-outline",
          title: "Rapportert av",
          content: this.value.createdBy,
        },
        {
          icon: "mdi-calendar",
          title: "Rapportert dato",
          content: this.value.lineCreatedDate
            ? moment(this.value.lineCreatedDate).format("DD.MM.YYYY")
            : "",
        },
      ];

      return profileItems;
    },
  },
  components: {
    StandardCard,
    CardContent,
    CardContentDesc,
    EditProfileDialog,
  },
});
</script>
